// bao migrate skip
import * as ko from "knockout";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import Bao from "./../../services/bao-service";
import * as $ from "jquery";
import { parseNumber } from "devextreme/localization";
class RequestResetPassowrd {

	constructor(languageSymbol, userName) {
		const self: any = this;
		const captionOK = Bao.Session.GetMessageBySymbol("msgOk", languageSymbol);
		const captionCancel = Bao.Session.GetMessageBySymbol("msgCancel", languageSymbol);
		const successMessage = Bao.Session.GetMessageBySymbol("BAO_RequestResetPasswordSuccess", languageSymbol);
		const failedMessage = Bao.Session.GetMessageBySymbol("BAO_RequestResetPasswordFailed", languageSymbol);
		const requestPasswordResetFn = function () {
			if (self.RequestResetPasswordDialog.ViewModel().CompleteCheck()) {
				Bao.post("BaoDialog/RequestResetPassword", JSON.stringify({
					username: self.RequestResetPasswordDialog.ViewModel().Username(),
					languageSymbol: languageSymbol
				}), function (value) {
					if (value == true) {
						const infoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, successMessage);
						infoDialog.Buttons([{
							Title: captionOK,
							Click: infoDialog.Close,
							Enabled: ko.observable(true)
						}]);
						infoDialog.Width(300);
						infoDialog.Open();
						self.RequestResetPasswordDialog.Close();
					} else {
						const infoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, failedMessage);
						infoDialog.Buttons([{
							Title: captionOK,
							Click: infoDialog.Close,
							Enabled: ko.observable(true)
						}]);
						infoDialog.Width(300);
						infoDialog.Open();
					}
				});
			}
		};
		Bao.Session.GetMessageBySymbol("BAO_RequestResetPasswordTitle", languageSymbol).then(function (dialogTitle) {
			Bao.post("BaoDialog/RequestResetPasswordDialog", function (value) {
				let title = Bao.Session.ApplicationName();
				title = title + " - " + dialogTitle;
				self.RequestResetPasswordDialog = new BaoDialogViewModel(title);
				self.RequestResetPasswordDialog.Buttons([{
					Title: captionOK,
					Click: requestPasswordResetFn,
					Enabled: ko.observable(true)
				}, {
					Title: captionCancel,
					Click: function () {
						self.RequestResetPasswordDialog.Close();
					},
					Enabled: ko.observable(true)
				}]);
				self.RequestResetPasswordDialog.Template(value);
				self.RequestResetPasswordDialog.ViewModel(new RequestResetPasswordModel(languageSymbol, userName));
				self.RequestResetPasswordDialog.Width(600);
				self.RequestResetPasswordDialog.Open();
				self.RequestResetPasswordDialog.ViewModel().Focus();

				$(".modal-dialog").css("margin-top", "20%");
				$(".close").css("margin-top", "4px");
			});
		});
	}

}
function RequestResetPasswordModel(languageSymbol, userName) {
	const self = this;
	self.Username = ko.observable(userName);
	self.Focus = function () { };
	const messageMandatoryFields = Bao.Session.GetMessageBySymbol("msgFillMandatorFields", languageSymbol);
	self.CaptionUsername = ko.observable();
	self.CaptionDescription = ko.observable();
	self.CaptionOk = ko.observable();
	Bao.Session.GetCaptions("RequestResetPasswordDialog", languageSymbol).then(function (captions) {
		self.CaptionUsername(captions.lblUsername);
		self.CaptionDescription(captions.lblDescription);
		self.CaptionOk(captions.btnOk);
	});
	self.CompleteCheck = function () {
		let isComplete = true;
		if (Bao.Utils.String.IsNullOrEmpty(self.Username())) {
			isComplete = false;
		}
		if (!isComplete) {
			const infoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, messageMandatoryFields);
			infoDialog.Buttons([{
				Title: self.CaptionOk(),
				Click: infoDialog.Close,
				Enabled: ko.observable(true)
			}]);
			infoDialog.Width(300);
			infoDialog.Open();
		}
		return isComplete;
	};
}
export default RequestResetPassowrd;
